// Module-level state for Keycloak auth mode.
// Set during app initialization by KeycloakAuthContext and read
// by non-React helpers (fetchApi, handleApiResponse, etc.).

let _isKeycloakMode = false;

export const keycloakAuthState = {
  get isKeycloakMode() {
    return _isKeycloakMode;
  },
  setKeycloakMode(value: boolean) {
    _isKeycloakMode = value;
  },
};
